import { createElement } from "react";
import { cn } from "@/lib/utils";

type As = "p" | "span" | "div" | "label";

type CopyTextSize = "tall" | "regular";

type CopyTextProps = {
  as?: As;
  size?: CopyTextSize;
} & JSX.IntrinsicElements[As];

const CopyText = ({
  as = "p",
  size = "regular",
  className,
  ...rest
}: CopyTextProps) =>
  createElement(as, {
    className: cn(
      {
        ["text-subline"]: size === "tall",
        ["text-copy"]: size === "regular",
      },
      className
    ),
    ...rest,
  });

export { CopyText };
